export enum InteractionTypeEnum {
  Presential = 1,
  Remote = 2,
}
